









































import {Component, Vue} from 'vue-property-decorator';
import ExposomeGlobe from "../components/ExposomeGlobe.vue";
import {Data, RGBA} from "@/@types/data";
import papaparse, {ParseResult, ParseError} from 'papaparse';
import ExposomeGlobeDrawer from "@/components/ExposomeGlobeDrawer.vue";
import { Value as ExposomeConfig } from "@/components/ExposomeGlobeDrawer";
//import {TabulatorComponent} from "vue-tabulator";

import Instructions from '#/globe.md';

const defaultTabOpts = {
    sorter: 'string',
    width: 200,
    editor: true,
};

@Component({
    components: {ExposomeGlobeDrawer, ExposomeGlobe, /*TabulatorComponent, */ Instructions: Instructions.vue.component}
})
export default class Visualization extends Vue {
    $refs!: {
        globe: ExposomeGlobe;
    };
    private title = 'exposome-globe';
    private value: Data[] = [];
    private error?: ParseError | string;
    private globeOptions: ExposomeConfig = {
        threshold: 0.0,
        sort: "value",
        fontSize: 15,
        padding: 110,
        positiveCorrelationColor: {r: 79, g: 117, b: 210},
        negativeCorrelationColor: {r: 223, g: 60, b: 60},
        backgroundColor: {r: 255, g: 255, b: 255, a: 0},
    };
    private tabOptions = {
        pagination: 'local',
        paginationSize: 10,
        columns: [
            {
                title: 'variable1',
                field: 'variable1',
                ...defaultTabOpts,
            },
            {
                title: 'var1_domain',
                field: 'var1_domain',
                ...defaultTabOpts,
            },
            {
                title: 'variable2',
                field: 'variable2',
                ...defaultTabOpts,
            },
            {
                title: 'var2_domain',
                field: 'var2_domain',
                ...defaultTabOpts,
            },
            {
                title: 'coef',
                field: 'coef',
                ...defaultTabOpts,
                sorter: 'number',
            },
        ],
    };

    load(file: File | string): void {
        console.debug('Started parsing %O', file);
        this.title = ((typeof file === 'string') ? file : file.name).split('.').slice(0, -1).join('.');
        papaparse.parse(file, {
            download: typeof file === 'string',
            header: true,
            dynamicTyping: true,
            skipEmptyLines: 'greedy',
            complete: (results: ParseResult) => {
                if (!(this.tabOptions.columns.every(c => results.meta.fields.includes(c.field)))) {
                    this.value = [];
                    this.error = `Unexpected columns in data, should only contain [${this.tabOptions.columns.map(c=>c.field).join(", ")}]`;
                    console.debug(this.error);
                } else {
                    this.value = results.data;
                    this.error = undefined;
                    console.debug('Finished parsing data: %O', this.value);
                }
            },
            error: (error: ParseError) => {
                this.value = []
                this.error = error;
                console.debug('Failed parsing data: %O', error);
            }
        })
    }

    mounted(): void {
        if (this.$route.query.view) this.load(this.$route.query.view as string);
        for (const key of Object.keys(this.globeOptions)) {
            const query = this.$route.query[key];
            if (typeof query === "string") {
                const option = this.globeOptions[key];
                if (typeof option === "number") {
                  this.globeOptions[key] = parseFloat(query);
                /*} else if (typeof option === "boolean") {
                  const q = query.toLowerCase();
                  this.globeOptions[key] = (q === 'true' || q === 't' || q === '1' || q === 'y')
                */} else if (query.includes(',')) {
                    const components = query.split(',');
                    const rgba = this.globeOptions[key] as RGBA;
                    rgba.r = parseInt(components[0]);
                    rgba.g = parseInt(components[1]);
                    rgba.b = parseInt(components[2]);
                    if (components.length === 4)
                        rgba.a = parseFloat(components[3]);
                } else {
                  this.globeOptions[key] = query;
                }
            }
        }
    }
}
